import { render } from "./Legend.vue?vue&type=template&id=2d1af93c&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"

import "./Legend.vue?vue&type=style&index=0&id=2d1af93c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1af93c"]])

export default __exports__